export const zahtjev_brisanje= {
  templateId: 94,
  category: 9,
  templateTitle: "Zahtjev za brisanje osobnih podataka - GDPR",
  templateDescription: `<p>Zahtjev za brisanje osobnih podataka je pravo ispitanika koje proizlazi iz Uredbe, čije nepoštivanje od strane voditelja obrade je kažnjivo.</p>`,
  description: `
    <h5>OPIS  DOKUMENTA</h5>
    <p>Ispitanik ima pravo od voditelja obrade ishoditi brisanje osobnih podataka koji se na njega odnose bez nepotrebnog odgađanja te voditelj obrade ima obvezu obrisati osobne podatke bez nepotrebnog odgađanja ako su ispunjeni uvjeti određeni Općom Uredbom o zaštiti podataka.</p>
    <p>Napomena: ovaj dokument se ispunjava tek nakon ispisa na pisaču.</p>
    
    <h5>PRAVNA OSNOVA</h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
    `,
    sides: [
      {
          prefix: 'Na temelju Opće uredbe o zaštiti podataka,',

          signature: "Podnositelj zahtjeva:",
            inputs: [{
              type: "input",
              required: true,
              placeholder: "Ime i prezime",
            },
            {
              type: "input",
              required: false,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: false,
              placeholder: "Mjesto",
            },
            ],
      }
  ],
  headline: "podnosim sljedeći",
  title: "ZAHTJEV ZA BRISANJE OSOBNIH PODATAKA",

  noArticleNumbers: true,

  articles: [ 
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "1. VODITELJ OBRADE:\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "NAZIV: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "SJEDIŠTE: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "ADRESA: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "OIB: _________________________"},
        
          ],
        }
      ]
    }, 
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "2. RAZLOG BRISANJA OSOBNIH PODATAKA (označiti odabir):\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ osobni podaci više nisu nužni u odnosu na svrhe za koje su prikupljeni ili na drugi način obrađeni i/ili\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ povlačenje privole za obradu osobnih podataka za koju više ne postoji pravna osnova za obradu i/ili,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ uslijed prigovora na obradu koja se provodi uslijed izvršavanja zadaće od javnog interesa ili pri izvršavanju službene ovlasti voditelja obrade odnosno obrade koja je nužna za potrebe legitimnih interesa voditelja obrade ili treće strane te ne postoji jači legitimni interesi i/ili,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ uslijed prigovora na obradu osobnih podataka za potrebe izravnog marketinga i/ili,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ osobni podaci moraju se brisati radi poštovanja pravne obveze iz prava Unije ili prava države članice kojem podliježe voditelj obrade i/ili,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ osobni podaci prikupljeni su u vezi s ponudom usluga informacijskog društva djetetu (ispod 16 godina)."},
           
          ],
        }
      ]
    }, 
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "3. PODACI KOJE JE POTREBNO BRISATI:\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "________________________________________________________________________\r\n"},               
          ],
        }
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/94_zahtjev_brisanje.ts